<template>
  <div class="card card-custom card-stretch mb-5">
    <div class="card-header align-items-center border-0 mt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bolder text-dark fs-3">
          Размер выделяемых долей
        </span>
      </h3>
    </div>
    <div class="card-body pt-9">
      <div class="table-responsive">
        <table class="table table-borderless table-hover">
          <thead>
          <tr class="fw-bold text-gray-800 border-bottom border-gray-200">
            <th></th>
            <Year v-for="item in this.years" :year="item.year" :status="item.status"/>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th class="fw-bold text-gray-800">Базовый опцион</th>
            <td v-for="item in this.years">
              <SharePercent :value="item.common.percent" :employees="item.common.employees"/>
            </td>
          </tr>
          <tr>
            <td class="fw-bold text-gray-800">Опцион за достижения</td>
            <td v-for="item in this.years">
              <SharePercent :value="item.heightened.percent" :employees="item.heightened.employees"/>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {chain, groupBy} from "lodash"

import SharePercent from "./components/SharePercent";
import Year from "./components/Year";

export default {
  components: {Year, SharePercent},

  props: {
    years: Array,
  },
}
</script>
